import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { QueryClientProvider } from '@tanstack/react-query'
import { RouterProvider } from 'react-router-dom'
import { Toaster } from 'sonner'

import './styles/theme.css'
import { router } from './router'
import { queryClient } from './lib/queryClient'
import { AuthProvider } from './providers/AuthProvider'
import { ConfirmHost } from './components/ui/ConfirmDialog'
import { UpdatePrompt } from './components/pwa/UpdatePrompt'
// Импорт до первого рендера, а не ради значения: модуль подписывается
// на beforeinstallprompt сразу. Событие одноразовое и приходит рано —
// слушатель, поднятый в ленивой ветке кабинета, его уже не застаёт.
import './lib/pwaInstall'

const container = document.getElementById('root')
if (!container) {
  throw new Error('Не найден корневой элемент #root')
}

createRoot(container).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <AuthProvider>
        <RouterProvider router={router} />
        <ConfirmHost />
        {/*
          Баннер обновления вне роутера: новая версия Service Worker может
          приехать на любом экране, и предложить перезагрузку надо везде.

          А вот предложение установить приложение живёт в AppShell: гостю,
          который только открыл лендинг и ещё не понял, что это за сервис,
          оно приходит слишком рано и закрывает первый экран.
        */}
        <UpdatePrompt />
        <Toaster
          position="top-center"
          richColors
          // Крупнее стандартного: аудитория приложения — в основном 40+
          toastOptions={{ style: { fontSize: '15px' } }}
        />
      </AuthProvider>
    </QueryClientProvider>
  </StrictMode>,
)
